<template>
  <div class="login">
    <v-container fluid fill-height class="loginOverlay">
      <v-layout flex align-center justify-center>
        <v-flex xs12 sm4>
          <v-card
            v-model="valid"
            :loading="loading"
            elevation="9"
            lazy-validation
          >
            <v-card-title>
              <h4>Administartion Console</h4>
            </v-card-title>
            <v-card-text class="pt-4">
              <v-form ref="form">
                <v-text-field
                  v-for="(item, key) in fields"
                  :key="key"
                  v-model="values[item.name]"
                  :label="item.title"
                  :rules="Rules(item)"
                  autocomplete="on"
                  :type="item.type"
                  required
                  append-icon="fa-info-circle"
                />
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn class="green white--text" @click="handleSubmit">
                Sign in
              </v-btn>
            </v-card-actions>
            <v-alert
              v-if="isLoginError"
              border="bottom"
              color="red"
              dismissible
              text
              dense
              type="error"
            >
              {{ LoginError }}
            </v-alert>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { getLoginForm } from '@/graphql/auth'

export default {
  auth: false,
  apollo: {
    getLoginForm: {
      query: getLoginForm,
      error (err) {
        const message = err.message.split(': ')
        this.isLoginError = true
        this.LoginError = message[1] || 'Error'
      }
    }
  },
  data () {
    return {
      valid: false,
      email: '',
      password: '',
      isLoginError: false,
      LoginError: '',
      loader: false,
      values: {}
    }
  },
  computed: {
    fields () {
      const form = this.$apolloData.data.getLoginForm
      if (form !== undefined && form.fields !== undefined) {
        return form.fields
      } else {
        return []
      }
    },
    loading: {
      get () {
        const { getLoginForm } = this.$apollo.queries
        return getLoginForm.loading || this.loader
      },
      set (val) {
        return val
      }
    }
  },
  watch: {
    isLoginError (val) {
      if (val) {
        setTimeout(() => {
          this.isLoginError = false
        }, 3000)
      }
    }
  },
  mounted () {
    if (this.$auth.loggedIn) {
      this.$router.push('/')
    }
  },
  methods: {
    Rules (item) {
      if (item.name === 'email') {
        return [
          v => !!v || 'E-mail обязательный',
          v => /.+@.+\..+/.test(v) || 'E-mail не валидный'
        ]
      }
    },
    // handler
    handleSubmit () {
      if (this.valid) {
        this.loading = true
        const param = []
        const { getLoginForm } = this.$apolloData.data
        const flow = getLoginForm.flow
        const { values } = this
        for (const item in values) {
          if (values[item]) {
            param.push({
              name: item,
              value: values[item]
            })
          }
        }
        this.$auth
          .loginWith('apollo', {
            form: {
              flow,
              type: 'email',
              fields: param
            }
          })
          .then(() => {
            this.loginSuccess()
          })
          .catch((err) => {
            this.requestFailed(err)
          })
      }
      this.loading = false
    },
    loginSuccess () {
      this.$router.push('/')
    },
    requestFailed (err) {
      console.error(err)
      const message = err.message.split(': ')
      this.loading = false
      this.isLoginError = true
      this.LoginError = message[1] || err
    }
  }
}
</script>

<style scoped>
.login {
  height: 100vh;
}
h4 {
  font-size: 1em !important;
  padding: 1em;
  color: black;
}
.v-card {
  text-align: center;
  margin: 1em;
}
.v-card__title {
  justify-content: center;
}
.v-btn {
  width: 100%;
}
.link-color {
  color: #d38841;
  text-decoration: none;
}
.v-card {
  padding: 1em;
}
.v-card__actions {
  display: block;
}
.green {
  margin-bottom: 1em;
}
.create {
  text-transform: capitalize;
  margin-bottom: 1em;
}
.row {
  font-size: 0.7em;
  justify-content: center;
}
.row-item {
  padding: 0 0.7em;
}
.border {
  border-right: 1px solid black;
}
</style>
